import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { downloadFile } from "../../../common/download";
import Modal from "../../../components/Modal";
import LenderUgroService from "../../../services/lender";

const FundoutBulkModal = ({
  toggleModal,
  userType,
  leadId,
  state,
  reloadTable,
}) => {
  const inputRef = useRef(null);

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sampleLoader, setSampleLoader] = useState(false);

  const [errors, setErrors] = useState();
  const formSubmitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response;
      let formData = new FormData();
      formData.append("file", file);
      response = await LenderUgroService.bulkfundoutupload(
        userType,
        formData,
        userType === "admin" ? "co-lender" : ""
      );

      if (response?.data?.status?.code === 1) {
        toast.success(
          response?.data?.messages?.success?.others[0]
        );
        toggleModal();
        reloadTable();
      }
    } catch (err) {
      let error = err?.response?.data?.messages?.error;

      toast.error(error?.form?.[0] || error?.others?.[0]);
      setErrors(error);
    }
    setLoading(false);
  };

  const DownloadSamplefile = async () => {
    try {
      setSampleLoader(true);
      let response;
      response = await LenderUgroService.getsamplefile({
        type: state.userType,
        dataExport: 1,
        responseType: 'blob',
      });
      downloadFile(response?.data, 'fundout_sample_template.xlsx');
      if (response?.data?.status?.code === 1) {
        toast.success(
          response?.data?.messages?.success?.others[0]
        );
      }
      setSampleLoader(false);
    } catch (err) {
      let error = err?.response?.data?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0]);
      setErrors(error);
      setSampleLoader(false);
    }
  }

  const closeModalByClick = ()=>{
    if(loading){
      toast.info("This process is ongoing and may take 2–3 minutes. Thank you for your patience.");
    }else{
      toggleModal();
    }
  }

  return (
    <Modal state={state} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true} closeOnOverlayClick={false}>
      <div className="modal-header-container">
        <div className="modal-title">Upload Bulk Fundout</div>
        <div className="closeModalView" onClick={closeModalByClick}>
          <span className="closeModalIcon">x</span>
        </div>
      </div>
        <div className="text-right px-4 pt-2">
          {sampleLoader ? <div className="loader" style={{float: 'right'}}></div> : 
          <a style={{ color: "#007bff", cursor: "pointer" }} onClick={DownloadSamplefile}>
            Sample file
          </a>
          }
        </div>
      <div className="p-4 modalData">

        <form onSubmit={formSubmitHandler}>
          <div class="form-group">
            <label>Upload File</label>
            <div class="row">
              <div class="col-12">
                <input
                  ref={inputRef}
                  file={file}
                  onChange={(e) => setFile(e.target.files[0])}
                  type="file"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <button type="submit" class="btn btn-custom btn-custom-height p-0" disabled={!file || loading}>
              {loading ? <div className="loader" /> : "Submit"}
            </button>
            <button
              type="button"
              class="btn btn-outline-custom ml-2"
              data-dismiss="modal"
              onClick={closeModalByClick}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default FundoutBulkModal;
